const apiErrorMessageMap = {
  'File too large.': 'Gagal upload. Ukuran file maksimal 5 MB.',
};

const getApiErrorMessage = (apiMessage, fallback = 'Terjadi kesalahan. Silakan coba lagi.') =>
  apiErrorMessageMap[apiMessage] || apiMessage || fallback;

export default getApiErrorMessage;
